import { useRef, useState, useEffect, useContext } from 'react'

import Input from 'common-components/Input'
import { AudioContentContext } from 'containers/SubSidebar/AudioContent/context'
import debounce from 'lodash.debounce'

interface IProps {
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  className?: string
}

export const AudioSearchInput: React.FC<IProps> = ({
  placeholder,
  value,
  onChange,
  className
}) => {
  const [searchValue, setSearchValue] = useState(value)
  const { setIsAudioSearchLoading } = useContext(AudioContentContext)

  useEffect(() => {
    return () => {
      setIsAudioSearchLoading(false)
    }
  }, [setIsAudioSearchLoading])

  const onDebounceChange = useRef(
    debounce(value => {
      setIsAudioSearchLoading(false)
      if (onChange) {
        onChange(value)
      }
    }, 500)
  )

  useEffect(() => {
    setSearchValue(value)
  }, [value])

  return (
    <Input
      type="search"
      onChange={value => {
        setIsAudioSearchLoading(true)
        setSearchValue(value)
        onDebounceChange.current(value)
      }}
      placeholder={placeholder}
      value={searchValue}
      onClearValue={() => {
        setSearchValue('')
        setIsAudioSearchLoading(false)
        if (onChange) {
          onChange('')
        }
      }}
      className={className}
    />
  )
}
